import { errorLogger } from './errorLogger.js';

// Базовые настройки API
const API_CONFIG = {
    baseURL: '/api',
    timeout: 5000
};

// Общая функция для выполнения запросов
async function fetchAPI(endpoint, options = {}) {
    try {
        const {
            method = 'GET',
            body,
            headers = {},
            ...restOptions
        } = options;

        const requestOptions = {
            method,
            headers: {
                'Content-Type': 'application/json',
                ...headers
            },
            ...restOptions
        };

        if (body !== undefined) {
            requestOptions.body = typeof body === 'string' ? body : JSON.stringify(body);
        }

        const response = await fetch(`${API_CONFIG.baseURL}/${endpoint}`, requestOptions);
        const data = await response.json();

        if (!response.ok) {
            const error = new Error(data.error || `HTTP error! status: ${response.status}`);
            error.status = response.status;
            error.data = data;
            throw error;
        }

        return data;
    } catch (error) {
        console.error(`API Error (${endpoint}):`, error);
        
        // Отправляем ошибку на сервер через errorLogger
        errorLogger.logError({
            error_type: 'api_error',
            message: `API Error (${endpoint}): ${error.message}`,
            stack: error.stack,
            url: window.location.href,
            additional_info: {
                endpoint: endpoint,
                method: options.method || 'GET',
                status: error.status || null,
                error_data: error.data || null,
                request_body: body ? (typeof body === 'string' ? body : JSON.stringify(body)) : null
            }
        });
        
        throw error;
    }
}

// Специализированные функции API
export const fetchUserData = (userId) => fetchAPI(`user/${userId}`);
export const fetchUserProgressData = (userId) => fetchAPI(`user_progress/${userId}`);
export const fetchSongData = (songId) => fetchAPI(`song_data/${songId}`);
export const fetchSongParts = (songId) => fetchAPI(`song_sequences/${songId}`);
export const saveUserProgress = (payload) => fetchAPI('user_progress', { method: 'POST', body: payload });
export const saveFullSequenceStats = (payload) => fetchAPI('full_sequence_stats', { method: 'POST', body: payload });
export const fetchUserFullSequenceStats = (userId) => fetchAPI(`full_sequence_stats/${userId}`);
export const resetUserProgress = (userId) => fetchAPI('user_progress/reset', { method: 'POST', body: { user_id: userId } });
export const fetchUserGameState = (userId) => fetchAPI(`user_game_state/${userId}`);
export const saveUserGameState = (payload) => fetchAPI('user_game_state', { method: 'POST', body: payload });

// Авторизация
export const registerUser = (username, password) => 
    fetchAPI('auth/register', { method: 'POST', body: { username, password } });

export const loginUser = (username, password) => 
    fetchAPI('auth/login', { method: 'POST', body: { username, password } });